import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

/**
 * A single address suggestion returned by the backend address autocomplete endpoint.
 */
export interface AddressSuggestion {
  freeformAddress: string;
  street: string;
  streetNumber: string;
  postalCode: string;
  municipality: string;
  position: { lat: number, lon: number };
}

/**
 * Service to fetch live street-address suggestions from the backend, which proxies the Azure Maps search API.
 */
@Injectable({
  providedIn: 'root'
})
export class AddressAutocompleteService {

  /**
   * constructor
   * @param http
   */
  constructor(protected http: HttpClient) {
  }

  /**
   * Search for address suggestions matching a query, biased towards a postal code.
   * @param query
   * @param postalCode
   */
  search(query: string, postalCode: string): Observable<AddressSuggestion[]> {
    return this.http.get<AddressSuggestion[]>('/address/autocomplete', {params: {query, postalCode: postalCode ?? ''}}).pipe(
      catchError((error) => {
        console.error("AddressAutocompleteService: Error while fetching address suggestions.", error);
        return of([]);
      })
    );
  }
}
